/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetShiftsOverviewRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {GetShiftsOverviewResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getShiftsOverview = (request: GetShiftsOverviewRequest, options?: CashRequestOptions) => post<GetShiftsOverviewRequest, GetShiftsOverviewResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetShiftsOverview", request, {...options, rejectOnError: true })